import { headerAuth } from "../standardAuthPatterns";
import { defineProduct, productVariant } from "../types";
import { oauthSetupSteps } from "../oauthSetupSteps";
import { oauthAuth } from "../standardAuthPatterns";
import logo from "./logo.svg";

const credential = productVariant({
  authLabel: "Bot token",
  identifier: "discord",
  keywords: "guilds servers channels dms messaging bot voice",
  protocol: "http",
  defaultUrlPattern: () => "https://discord\\.com/api/.*",
  auth: (app) =>
    headerAuth([
      {
        name: "Authorization",
        value: app.secret.botToken,
        scheme: "Bot",
      },
    ]),
  steps: [
    {
      title: "Create a Discord bot",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Discord Developer Portal](https://discord.com/developers/applications) and create a new application, or select an existing one.\n\nNavigate to the **Bot** tab and create a bot if you haven’t already. Enable the necessary intents for your use case.",
        },
      ],
    },
    {
      title: "Copy and paste your bot token here",
      items: [
        {
          kind: "markdown",
          content:
            "On the **Bot** tab, click **Reset Token** (or **Copy** if you haven’t done so yet) to get your bot token.\n\n**Keep this token secret** — anyone with access can control your bot.",
        },
        {
          kind: "input",
          label: "Bot token",
          placeholder: "MTIzNDU2Nzg5MDEyMzQ1Njc4OQ...",
          required: true,
          target: { kind: "secrets", field: "botToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://discord.com/api/v10/users/@me",
  },
});

export const discord = defineProduct({
  name: "Discord",
  tagLine: "Community and team chat",
  logo,
  tags: ["featured", "communication"],
  variants: [
    credential,
    productVariant({
      identifier: "discordOAuth",
      authLabel: "OAuth",
      protocol: "http",
      defaultUrlPattern: () => "https://discord\\.com/api/.*",
      auth: oauthAuth,
      steps: oauthSetupSteps({
        identifier: "discordOAuth",
        registrationUrl: "https://discord.com/developers/applications",
        scopes: ["identify"],
        instructions:
          "User authorization accesses only the approved OAuth scopes. Use the bot token option for bot messages and guild administration.",
      }),
      oauth: {
        grantType: () => "authorization_code",
        authorizationEndpoint: () => "https://discord.com/oauth2/authorize",
        tokenEndpoint: () => "https://discord.com/api/oauth2/token",
        tokenEndpointAuthMethod: () => "client_secret_post",
        clientCredentialsFrom: "db",
        scopes: () => ["identify"],
        pkce: () => false,
      },
      connectionTest: {
        protocol: "http",
        request: () => "https://discord.com/api/v10/users/@me",
      },
    }),
  ],
});
